<p-progressSpinner [style]="{ width: '50px', height: '50px'}"></p-progressSpinner>
